import React from 'react';
import { ClickAwayListener, Popper } from '@material-ui/core';
import Calendar from './Calendar';

function ShowCalender({ open, anchorEl, cbHandleClose }) {
	const handleClose = () => {
		cbHandleClose();
	};

	const clickAwayHandler = (e) => {
		if (!['start-date', 'end-date'].includes(e.srcElement.id)) {
			cbHandleClose();
		}
	};

	return (
		<ClickAwayListener onClickAway={clickAwayHandler}>
			<Popper
				placement="left"
				id={'cal-popover'}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchororigin={{
					vertical: 'bottom',
					horizontal: 'center'
				}}
				transformorigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
				style={{ zIndex: 99 }}>
				<Calendar />
			</Popper>
		</ClickAwayListener>
	);
}

export default ShowCalender;
